import { Image, styled } from '@volkswagen-onehub/components-core';
import { useTransform, motion, MotionValue } from 'framer-motion';
import React from 'react';

const ImagesContainer = styled.div`
	--column-proportion: ${(1 / 24) * 100}vw;
	--aspect-ratio: 0.82;

	--calculated-width-mobile: calc(var(--column-proportion) * 7.5);
	--calculated-height-mobile: calc(var(--calculated-width-mobile) / var(--aspect-ratio));
	--calculated-width-desktop: calc(var(--column-proportion) * 3.79);
	--calculated-height-desktop: calc(var(--calculated-width-desktop) / var(--aspect-ratio));

	& img {
		width: var(--calculated-width-mobile);
		height: var(--calculated-height-mobile);
		border-radius: 16px;
		object-fit: cover;

		@media screen and (min-width: 960px) {
			width: var(--calculated-width-desktop);
			height: var(--calculated-height-desktop);
		}
	}
`;

export const VipsImagesContainer = ({
	images,
	direction,
	horizontal,
	scrollProgress,
}: {
	images: string[];
	direction: 'ltr' | 'rtl';
	horizontal: boolean;
	scrollProgress: MotionValue<number>;
}): React.ReactElement => {
	const trackMovement = useTransform(
		scrollProgress,
		[0, 1],
		direction === 'rtl' ? ['30vw', '-30vw'] : ['-30vw', '30vw'],
	);

	return (
		<motion.div
			style={{
				x: horizontal ? trackMovement : undefined,
				y: horizontal ? undefined : trackMovement,
				display: 'flex',
				flexDirection: horizontal ? 'row' : 'column',
				gap: '12px',
				width: 'fit-content',
				height: 'fit-content',
			}}
		>
			{images.map((image, index) => (
				<ImagesContainer key={index}>
					<Image src={image} alt="image" />
				</ImagesContainer>
			))}
		</motion.div>
	);
};
